<h2 mat-dialog-title>Unsaved Changes</h2>
<mat-dialog-content>There are unsaved changes on this page. All these changes will be lost.
  <br>Are you sure you want to continue?</mat-dialog-content>
<mat-dialog-actions>
  <div class="dialog-btn-row">
    <button class="btn btn-success" [mat-dialog-close]="true" (click)="onContinue()">Yes</button>
    <button class="btn btn-warning" style="margin-left: 5px;" [mat-dialog-close]="true" (click)="onCancel()">No</button>
  </div>
</mat-dialog-actions>
